import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'

export const PrivateRouteContainer = styled(Box)`
	display: flex;
	flex-direction: column;
	padding: 40px 20px;
	text-align: center;
	max-width: max-content;
	margin: auto;

	h1 {
		font-size: 1.5em;
		margin-bottom: 10px;
	}

	p {
		color: #777;
		margin-bottom: 30px;
	}

	span {
		color: #007bff;
		text-decoration: none;
		font-size: 0.9em;
	}
`
